export { default as PaymentMethodList } from './PaymentMethodList';
export { default as PaymentMethodEdit } from './PaymentMethodEdit';


// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/pages/index.ts